// src/sections/Contact.js
import React from 'react';
import styled from 'styled-components';
import { colors, fontSizes, mq, radii, space } from '../styles/tokens';
import { SectionHeading } from '../components/SectionHeading';
import { ButtonLink } from '../components/Button';
import { CopyableText } from '../components/CopyableText';
import { Icon } from '../components/Icon';

const Section = styled.section`
  padding: ${space[10]} ${space[4]} ${space[10]};
  max-width: 560px;
  margin: 0 auto;
  text-align: center;
  ${mq.md} { padding: ${space[12]} ${space[5]}; }
`;

const Lead = styled.p`
  font-size: ${fontSizes.md};
  color: ${colors.textDim};
  margin-bottom: ${space[4]};
`;

const Card = styled.div`
  background: ${colors.bgElev};
  border: 1px solid ${colors.border};
  border-radius: ${radii.lg};
  padding: ${space[2]} ${space[4]};
  margin-bottom: ${space[4]};
  text-align: left;
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space[2]};
  ${mq.md} { grid-template-columns: repeat(4, 1fr); }

  > * {
    justify-content: center;
    width: 100%;
  }
`;

const Contact = () => {
  return (
    <Section id="contact" aria-labelledby="contact-heading">
      <SectionHeading prefix="get in touch" id="contact-heading" center>Let's build something together.</SectionHeading>
      <Lead>Drop me a line or grab my CV.</Lead>
      <Card>
        <CopyableText value="fabiolillman@hotmail.com" label="email" />
        <CopyableText value="+46 (0)76-265 67 68" label="phone" />
      </Card>
      <Buttons>
        <ButtonLink href="mailto:fabiolillman@hotmail.com" $variant="ghost">
          <Icon name="mail" size={16} /> Email
        </ButtonLink>
        <ButtonLink href="https://www.linkedin.com/in/fabio-lillman/" target="_blank" rel="noopener noreferrer" $variant="ghost">
          <Icon name="linkedin" size={16} /> LinkedIn
        </ButtonLink>
        <ButtonLink href="https://github.com/Fabiolillman" target="_blank" rel="noopener noreferrer" $variant="ghost">
          <Icon name="github" size={16} /> GitHub
        </ButtonLink>
        <ButtonLink href={require('../assets/Fabio Lillman - CV.pdf')} download $variant="ghost">
          <Icon name="download" size={16} /> CV
        </ButtonLink>
      </Buttons>
    </Section>
  );
};

export default Contact;
